import { pages } from '@/settings/pages';
import { persistor } from '@/store';
import queryString from 'query-string';

export const urlSafeEncode = (str: string) => {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

type QueryParams = {
  error_message_key: string;
  prompt?: string;
};

export const reLogin = (queryParams: QueryParams): void => {
  persistor.purge();
  const signinUri = queryString.stringifyUrl({
    url: pages.signin.index,
    query: queryParams,
  });
  window.location.assign(signinUri);
};
